import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '919717841166'; // without + sign for WhatsApp API
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  const handleClick = (e) => {
    e.preventDefault();
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <a
      href={whatsappUrl}
      onClick={handleClick}
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <svg
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        className="whatsapp-icon"
      >
        <path
          fill="currentColor"
          d="M16 0C7.164 0 0 7.163 0 16c0 2.827.744 5.576 2.155 7.963L.057 31.35l7.629-2.013C10.03 30.743 12.967 32 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.217c-2.446 0-4.793-.684-6.826-1.976l-.49-.296-5.09 1.343 1.36-4.96-.324-.507A13.133 13.133 0 012.783 16c0-7.29 5.927-13.217 13.217-13.217S29.217 8.71 29.217 16 23.29 29.217 16 29.217zm7.254-9.893c-.398-.199-2.354-1.162-2.719-1.295-.365-.133-.631-.199-.896.199-.266.398-1.028 1.295-1.261 1.561-.232.266-.465.299-.863.1-.398-.199-1.68-.619-3.199-1.976-1.183-1.056-1.982-2.361-2.214-2.759-.233-.398-.025-.613.175-.811.179-.179.398-.465.597-.697.199-.232.266-.398.398-.664.133-.266.066-.498-.033-.697-.1-.199-.896-2.159-1.228-2.957-.324-.776-.653-.671-.896-.684-.232-.013-.498-.016-.764-.016s-.697.1-1.062.498c-.365.398-1.394 1.361-1.394 3.321s1.427 3.852 1.626 4.117c.199.266 2.807 4.286 6.799 6.009.95.409 1.691.653 2.269.836.953.303 1.82.26 2.506.158.764-.114 2.354-.963 2.686-1.892.332-.93.332-1.727.232-1.892-.1-.166-.365-.266-.764-.465z"
        />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
